import React from "react";
import MainLayout from "./MainLayout";
import WorkExperience from "../common/OnBoarding/OnBoardingWorkExperience";

const WorkExp = (props) => <MainLayout component={WorkExperience} />;

export default WorkExp;
